import Loader from '@/Utility/Loader';
import RADEnvironmentProxy from '@/Communication/RADEnvironmentProxy';
import ComponentManager from '@/Management/ComponentManager';
import RADApplication from '@/Management/RADApplication';
import MessageBoxViewModel from '@/ViewModels/Controls/MessageBoxViewModel';
import AssociationHelper from '@/Utility/Association/AssociationHelper';
import ResourceManager from '@/Management/ResourceManager';

export default class ObjectDisconnectionHelper extends AssociationHelper {
    private readonly DeleteWarningResourceIdentifier = "LISTVIEW_DISCONNECT_LEADS_TO_DELETE_WARNING";
    private readonly DeleteWithFollowingWarningResourceIdentifier = "LISTVIEW_DISCONNECT_LEADS_TO_DELETE_WARNING_WITH_FOLLOWING";

    public disconnectionCallback: Function;

    public constructor(params: any) {
        super(params);

        this.disconnectionCallback = this.handlerOrDefault(params.disconnectionCallback);
    }

    /**
     * @override
     */
    public ExecuteCheck(): void {
        this.TryToDisconnect();
    }


    public TryToDisconnect() {
        if (this.contextPdoId as unknown as number <= 0) {
            this.DisconnectionOk();
            return;
        }

        Loader.getInstance().show();

        RADEnvironmentProxy.getInstance().tryToDisconnectObject({
            pdoID: this.contextPdoId,
            assoziationName: this.associationName,
            topdTypeName: this.pdTypeName,
            pdoIDs: this.affectedObjectIds
        }).then((tryDeletion) => {
            if (this.validateStatus(tryDeletion)) {
                this.state("AfterTryToDisconnect");

                if (tryDeletion.objectsToDelete.length === 0) {
                    // Das Disconnect erfordert keine Löschung
                    this.DisconnectionOk();
                }
                else if (tryDeletion.objectsToDelete.length === 1 && tryDeletion.objectsToDelete[0].objects.length === 1) {
                    const msgVM = MessageBoxViewModel.createWarningMessageBox(ResourceManager.getInstance().get(this.DeleteWarningResourceIdentifier), this.confirmDeletionCallback, {}, true);
                    RADApplication.getInstance().showMessageBox(msgVM);


                    this.state("WaitingForDelete");
                }
                else if (tryDeletion.objectsToDelete.length >= 1) {
                    const msg = this.CreateMsgForDelete(ResourceManager, tryDeletion.objectsToDelete);

                    const msgVM = MessageBoxViewModel.createWarningMessageBox(msg, this.confirmDeletionCallback, {}, true);
                    RADApplication.getInstance().showMessageBox(msgVM);

                    this.state("WaitingForDelete");
                }

            }
        }).always(() => {
            Loader.getInstance().hide();
        });
    }

    private CreateMsgForDelete(RM, objectsToDelete): any {
        let msgRaw = RM.get(this.DeleteWithFollowingWarningResourceIdentifier);

        let sb = "";
        let itemErgNameValue = '';
        objectsToDelete.forEach((item) => {
            if (sb.length > 0) {
                sb += ', ';
            }
            if (item.objects.length > 1) {
                itemErgNameValue = item.ergNamePluralized;
            } else {
                itemErgNameValue = item.ergName;
            }

            sb += item.objects.length + 'x ' + RM.get(itemErgNameValue);
        });

        return msgRaw.replace("$$items$$", sb);
    }

    private DisconnectionOk() {
        this.disconnectionCallback();
        this.state("Finished");
    }
}

ComponentManager.setUtility('ObjectDisconnectionHelper', ObjectDisconnectionHelper, 'RADPresentation.HTMLClient.DefaultViewExtensions');